module.exports = __webpack_public_path__ + "img/content-bundles.97ed288f.jpg";